export default __webpack_public_path__ + "static/media/planning_icon.ee73b193.svg";